import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CAMPAIGN_ALL_LINK,CAMPAIGN_CALENDAR_LINK,CAMPAIGN_LEADS_URL,UNSUBSCRIBERS_LINK, MAIL_ACCOUNT_ALL_LINK,TEAMMATES_LINK,CONTACT_ALL_LINK } from "../constants/constants";

const Sidebar = () => {
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const handlePanel = () => {
        setIsPanelOpen(!isPanelOpen);
    }
    return(<>
        <div className={isPanelOpen ? 'sidebar-wrap close-panel' : 'sidebar-wrap open-panel'}>
            <div className="siderbar">
                <span className="panel-close" onClick={()=>{
                    handlePanel()
                }}> 
                    <i className={isPanelOpen ? 'bx bx-chevron-right' : 'bx bx-chevron-left'}></i>
                </span>
                <div className="profile-wrap">

                </div>
                <div className="sidebar-items">
                    <ul>
                        <li title="Dashboard">
                            <Link to="/">
                                <i className="bx bxs-user"></i> 
                                <span className="item-text">Dashboard</span>
                            </Link>
                        </li>
                        <li title="Campaigns">
                            <span className="no-link">
                                <i className="bx bxs-paper-plane"></i> 
                                <span className="item-text">Campaigns</span>
                            </span>
                            <ul className="submenu">
                                <li><Link to={CAMPAIGN_ALL_LINK}>Campaigns</Link></li>
                                <li><Link to={CAMPAIGN_LEADS_URL}>Leads</Link></li>
                                {/* <li><a href="/">Open Tasks</a></li> */}
                                <li><Link to={CAMPAIGN_CALENDAR_LINK}>Sending Calendar</Link></li>
                            </ul>
                        </li>
                        <li title="Contacts"><Link to={CONTACT_ALL_LINK}><i className="bx bxs-group"></i> <span className="item-text">Contacts</span></Link></li>
                        <li title="Mail Accounts"><Link to={MAIL_ACCOUNT_ALL_LINK}><i className="bx bxs-envelope"></i> <span className="item-text">Mail Accounts</span></Link></li>
                        <li title="Team Mates"><Link to={TEAMMATES_LINK}><i className="bx bxs-cog"></i> <span className="item-text">Teammates</span></Link>
                            {/* <ul className="submenu">
                                <li><a href="/">Settings</a></li>
                                <li><a href={TEAMMATES_LINK}>Teammates</a></li>
                                <li><a href="/">Billing</a></li>
                                <li><a href="/">Redeem</a></li>
                            </ul>*/}
                        </li>
                        <li title="Unsubscribes"><Link to={UNSUBSCRIBERS_LINK}><i className="bx bxs-user-x"></i> <span className="item-text">Unsubscribes</span></Link></li>
                    </ul>
                </div>
            </div>
        </div>
    </>);
}

export default Sidebar;